'use client';

import { useCollapseEqualHeight } from '@/components/FleetCategory/FleetCategoryComparisonCard/useCollapseEqualHeight';
import { Carousel, type CarouselProps } from '@/components/carousel/Carousel';

export function FleetCategoryAlternativesBlockCarousel({ children, options, ...props }: CarouselProps) {
    const ref = useCollapseEqualHeight();
    return (
        <Carousel
            ref={ref}
            options={{
                ...options,
                align: 'start',
                skipSnaps: true,
            }}
            {...props}
            showNavigation={true}
            spacing={0}
        >
            {children}
        </Carousel>
    );
}
